"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** =========================================================
 * Module: trigger-resize.js
 * Triggers a window resize event from any element
 ========================================================= */

/**
 * Attaches a click event to child element
 * and triggers a window resize event when clicked
 */
var TriggerResize = function TriggerResize(props) {
  var resize = function resize() {
    // all IE friendly dispatchEvent
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
    // modern dispatchEvent way
    // window.dispatchEvent(new Event('resize'));
  };

  return /*#__PURE__*/_react.default.cloneElement(_react.default.Children.only(props.children), {
    onClick: resize
  });
};
TriggerResize.propTypes = {
  /** only one children alloed */
  children: _propTypes.default.element.isRequired
};
var _default = exports.default = TriggerResize;